import $ from 'jquery';
import Unit from '../Global/_Unit.js';
// import { gsap } from 'gsap';

export default class MainContentResize {
  constructor() {}
  setMainContentHeight() {
    const hebiImgH = $('.hebi__container').height();
    let hebiH;

    // PC
    if (Unit.isPc()) {
      if ($(window).height() > hebiImgH) {
        hebiH = '';
      } else {
        hebiH = hebiImgH + 'px';
      }
    // SP
    } else {
      hebiH = '';
    }
    $('.mainContent').css('height', hebiH);
  }
}
